import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-code-icon',
  templateUrl: './text-code.component.html'
})
export class TextCodeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
